export class PrepagoConceptoRequest {
    mensaje:string;
	resultado:number;

	correoCliente:string
	codigoCliente:string
	tipoDocumentoCliente:string
	nroDocumentoCliente:string
	ip:string
	totalpagar:number;

	idpagoelectronico:number;
	codigocomercio:string
	urljsgenerarboton:string

	// Moneda para la pasarela de pagos (PEN o USD)
	moneda: string;
	// Código de moneda Niubiz (604 = PEN, 840 = USD)
	currencyCode: string;
}
